import { Component, OnInit } from '@angular/core';
import { UtilityService } from '../../../core/services/utility.service';
import { PerformanceService } from '../../../pages/performance/services/performance.service';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { OrderByPipe } from './../../../shared/pipe/order-by.pipe';

@Component({
  selector: 'app-initialize-modal',
  templateUrl: './initialize-modal.component.html',
  styleUrls: ['./initialize-modal.component.css']
})
export class InitializeModalComponent implements OnInit {

  format: string;
  datePickerOptions: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean; adaptivePosition: boolean };
  formData: { [key: string]: any } = {};
  count: number = 0;
  templateList: any[] = [];
  orderByPipe: any;
  emplData: any[] = [];
  filterEmplList: any[] = [];

  constructor(private utilityService: UtilityService, public activeModal: NgbActiveModal, private performanceService: PerformanceService) { }

  ngOnInit(): void {
    this.format = this.utilityService.getDateFormat();
    this.orderByPipe = new OrderByPipe();
    this.datePickerOptions = { dateInputFormat: this.format.toUpperCase(), containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false, adaptivePosition: true };
    this.formData.selectedAll = false;
    this.formData.dueDate = new Date(new Date().setDate(new Date().getDate() + 30))
    this.formData.disableSelfReview = false;
    this.formData.selectedManTemplate = null;
    this.getTemplate();
  }

  getTemplate() {
    this.performanceService.getTemplateCategories(-2).then((response: any[]) => {
      if (response != null) {
        this.templateList = [];
        response.forEach((val: any) => {
          if (val.ChecklistTemplateIsActive) {
            this.templateList.push(val);
          }
        })
      }
    });
  }

  getEmpl() {
    this.formData.selectedManTemplate = this.formData.selectedEmpTemplate;
    this.performanceService.getEmplByChecklistTemplateID(this.formData.selectedEmpTemplate).then((response: any[]) => {
      if (response != null) {
        this.emplData = response;
        this.emplData = this.orderByPipe.transform(response, "EmployeeName", "asc");
        this.filterEmplList = this.emplData;
        this.selectAll();
      }
    });
  }

  selectEmployee(data: any) {
    data.selected = !data.selected;
    this.count = 0;
    var errorCount = 0;
    this.emplData.forEach((val: any) => {
      if (val.selected) {
        this.count++;
      }
      else {
        this.formData.selectedAll = false;
        errorCount++;
      }
    });
    if (errorCount == 0) {
      this.formData.selectedAll = true;
    }
  }

  selectAll() {
    this.count = 0;
    if (this.formData.selectedAll) {
      this.emplData.forEach((val: any) => {
        val.selected = true;
        this.count++;
      });
    } else {
      this.emplData.forEach((val) => {
        val.selected = false;
      });
    }
  }

  filterList() {
    this.filterEmplList = [];
    this.emplData.forEach((val: any) => {
      if (this.formData.searchText != null && this.formData.searchText != "") {
        if ((val.EmployeeName != null ? val.EmployeeName.toLowerCase().indexOf(this.formData.searchText.toLowerCase()) > -1 : false) ||
          (val.Employee != null ? val.Employee.toString().toLowerCase().indexOf(this.formData.searchText.toLowerCase()) > -1 : false)) {
          this.filterEmplList.push(val);
        }
      } else {
        this.filterEmplList.push(val);
      }
    });
  }

  initializeClicked() {
    var emplString = "";
    this.emplData.forEach((val: any) => {
      if (val.selected) {
        emplString += val.UserKeyID + ","
      }
    });
    this.formData.initializing = true;
    var requestObj = {
      userKeyIDString: emplString, dateDueStr: moment(this.formData.dueDate).format("YYYY-MM-DD"), employeeChecklistTemplateID: this.formData.selectedEmpTemplate, managerChecklistTemplateID: this.formData.selectedManTemplate, disableSelfReview: this.formData.disableSelfReview
    }
    this.performanceService.initializePerformanceInstance(requestObj).then((response: any) => {
      this.formData.initializing = false;
      this.activeModal.close();
    });
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }

}
